"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const AuditLogPage_1 = require("./components/audit/AuditLogPage");
const LoginPage_1 = require("./components/auth/LoginPage");
const RequireAuth_1 = require("./components/auth/RequireAuth");
const CompaniesPage_1 = require("./components/companies/CompaniesPage");
const CompanyRecallReviewsPage_1 = require("./components/company-recalls/CompanyRecallReviewsPage");
const DashboardPage_1 = require("./components/dashboard/DashboardPage");
const DeadLettersPage_1 = require("./components/dead-letters/DeadLettersPage");
const DistributionRequestPage_1 = require("./components/distribution-requests/DistributionRequestPage");
const DistributionRequestsPage_1 = require("./components/distribution-requests/DistributionRequestsPage");
const DistributionPage_1 = require("./components/distributions/DistributionPage");
const DistributionsPage_1 = require("./components/distributions/DistributionsPage");
const AppLayout_1 = require("./components/layout/AppLayout");
const ManualDistributionPage_1 = require("./components/manual-distribution/ManualDistributionPage");
const QueuePage_1 = require("./components/queue/QueuePage");
const SettingsPage_1 = require("./components/settings/SettingsPage");
const VendorsPage_1 = require("./components/vendors/VendorsPage");
const YahooArticleEditorPage_1 = require("./components/yahoo-articles/YahooArticleEditorPage");
const YahooArticlesPage_1 = require("./components/yahoo-articles/YahooArticlesPage");
exports.router = (0, react_router_dom_1.createBrowserRouter)([
    { path: '/login', element: (0, jsx_runtime_1.jsx)(LoginPage_1.LoginPage, {}) },
    {
        path: '/',
        element: ((0, jsx_runtime_1.jsx)(RequireAuth_1.RequireAuth, { children: (0, jsx_runtime_1.jsx)(AppLayout_1.AppLayout, {}) })),
        children: [
            { index: true, element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/distribution-requests", replace: true }) },
            { path: 'dashboard', element: (0, jsx_runtime_1.jsx)(DashboardPage_1.DashboardPage, {}) },
            { path: 'distribution-requests', element: (0, jsx_runtime_1.jsx)(DistributionRequestsPage_1.DistributionRequestsPage, {}) },
            { path: 'distribution-requests/:requestId', element: (0, jsx_runtime_1.jsx)(DistributionRequestPage_1.DistributionRequestPage, {}) },
            { path: 'dead-letters', element: (0, jsx_runtime_1.jsx)(DeadLettersPage_1.DeadLettersPage, {}) },
            { path: 'audit', element: (0, jsx_runtime_1.jsx)(AuditLogPage_1.AuditLogPage, {}) },
            { path: 'queue', element: (0, jsx_runtime_1.jsx)(QueuePage_1.QueuePage, {}) },
            { path: 'vendors', element: (0, jsx_runtime_1.jsx)(VendorsPage_1.VendorsPage, {}) },
            { path: 'companies', element: (0, jsx_runtime_1.jsx)(CompaniesPage_1.CompaniesPage, {}) },
            { path: 'company-recalls', element: (0, jsx_runtime_1.jsx)(CompanyRecallReviewsPage_1.CompanyRecallReviewsPage, {}) },
            { path: 'distributions', element: (0, jsx_runtime_1.jsx)(DistributionsPage_1.DistributionsPage, {}) },
            { path: 'distributions/:id', element: (0, jsx_runtime_1.jsx)(DistributionPage_1.DistributionPage, {}) },
            { path: 'manual-distribution', element: (0, jsx_runtime_1.jsx)(ManualDistributionPage_1.ManualDistributionPage, {}) },
            { path: 'yahoo-articles', element: (0, jsx_runtime_1.jsx)(YahooArticlesPage_1.YahooArticlesPage, {}) },
            { path: 'yahoo-articles/new', element: (0, jsx_runtime_1.jsx)(YahooArticleEditorPage_1.YahooArticleEditorPage, {}, "new") },
            { path: 'yahoo-articles/:id', element: (0, jsx_runtime_1.jsx)(YahooArticleEditorPage_1.YahooArticleEditorPage, {}) },
            { path: 'settings', element: (0, jsx_runtime_1.jsx)(SettingsPage_1.SettingsPage, {}) },
        ],
    },
]);
